/* Confirm completed adds without replacing Customily's validation or cart requests. */
(() => {
  if (new URLSearchParams(location.search).has('ph_cart_edit') || window.phCartNoticeReady) return;
  window.phCartNoticeReady = true;
  const root = window.Shopify?.routes?.root || '/';
  if (window.T4Sconfigs) window.T4Sconfigs.afterActionATC = '1';
  const configure = () => {
    window.customilyShopify = window.customilyShopify || {};
    window.customilyShopify.addToCart = Object.assign({}, window.customilyShopify.addToCart, {
      reloadPageAfterAtc: false, urlToRedirectAfterAtc: '', openCartDrawerAfterAtc: false
    });
  };
  configure();
  window.addEventListener('customily-starts-adding-to-cart', configure);
  const notice = document.createElement('dialog');
  notice.className = 'ph-cart-notice'; notice.hidden = true;
  notice.setAttribute('aria-label', 'Added to cart');
  notice.innerHTML = '<button class="ph-cart-notice__close" type="button" aria-label="Close added to cart message">×</button><p role="status"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m7 12 3 3 7-7"/></svg>Added to cart successfully!</p><div><button type="button" class="ph-cart-notice__continue">Continue Shopping</button><a class="ph-cart-notice__checkout">Checkout</a></div>';
  notice.querySelector('a').href = root + 'cart';
  notice.querySelector('a').textContent = 'View Cart & Checkout';
  notice.querySelector('.ph-cart-notice__continue').textContent = 'Keep Shopping';
  notice.querySelector('p').lastChild.textContent = 'Item has been added to your shopping cart';
  notice.querySelector('p').id = 'ph-cart-notice-title';
  notice.setAttribute('aria-labelledby', 'ph-cart-notice-title');
  const itemPanel = document.createElement('section');
  itemPanel.className = 'ph-cart-notice__item';
  itemPanel.innerHTML = '<img class="ph-cart-notice__image" alt=""><div class="ph-cart-notice__details"><h3></h3><dl></dl><p class="ph-cart-notice__quantity"></p><p class="ph-cart-notice__price"></p></div>';
  notice.querySelector('p').after(itemPanel);
  let cartBefore = null, pending = null, addVersion = 0;
  const readCart = () => fetch(root + 'cart.js', {cache:'no-store'}).then(r => {if(!r.ok)throw Error('Cart unavailable');return r.json();});
  readCart().then(cart => {if(!pending)cartBefore=cart;}).catch(()=>{});
  function capture() {
    const form = document.querySelector('.t4s-product__info-wrapper form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    const variant = form?.querySelector('[name="id"]')?.value || new URLSearchParams(location.search).get('variant');
    const image = document.querySelector('.customily-modal-preview-only .cl-preview-image');
    const gallery = document.querySelector('.t4s-product__media-wrapper img');
    return {variant, quantity:Math.max(1,Number(form?.querySelector('[name="quantity"]')?.value)||1), title:document.querySelector('h1')?.textContent.trim() || '', image:image?.getAttribute('src') || gallery?.currentSrc || '', price:document.querySelector('.t4s-product-price ins')?.textContent.trim() || document.querySelector('.t4s-product-price')?.textContent.trim() || ''};
  }
  window.addEventListener('customily-starts-adding-to-cart', () => {pending=capture();addVersion++;});
  document.addEventListener('click', e => {if(e.target.closest?.('#customily-cart-btn,[data-atc-form]')&&!pending)pending=capture();},true);
  function renderItem(item, cart, before, snapshot) {
    const photo = itemPanel.querySelector('img'), title=itemPanel.querySelector('h3'), options=itemPanel.querySelector('dl');
    title.textContent=item?.product_title || snapshot?.title || '';
    let src=item?.featured_image?.url || item?.image || snapshot?.image;
    if(item?.properties){const preview=Object.entries(item.properties).find(([key,value])=>/preview/i.test(key)&&typeof value==='string'&&/^https:\/\//.test(value));if(preview)src=preview[1];}
    photo.hidden=!src;if(src){photo.src=src;photo.alt=title.textContent;photo.onerror=()=>{photo.onerror=null;const fallback=item?.featured_image?.url||item?.image;if(fallback&&fallback!==src)photo.src=fallback;else photo.hidden=true;};}
    options.replaceChildren();
    (item?.options_with_values || []).filter(o=>o.value!=='Default Title').forEach(o=>{const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=o.name+':';dd.textContent=o.value;row.append(dt,dd);options.append(row);});
    const previous=before?.items?.find(i=>i.key===item?.key)?.quantity || 0;
    const amount=item?Math.max(1,item.quantity-previous):snapshot?.quantity || 1;
    itemPanel.querySelector('.ph-cart-notice__quantity').textContent='Quantity: '+amount;
    itemPanel.querySelector('.ph-cart-notice__price').textContent=item ? new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:cart.currency,currencyDisplay:'code'}).format((item.final_price ?? item.price)/100) : snapshot?.price || '';
  }
  document.body.append(notice);
  let previousFocus, lastSuccess = 0, savedScroll = 0, scrollStyles = [], opening;
  const restore = () => {
    notice.hidden = true;
    document.documentElement.classList.remove('ph-cart-notice-open');
    scrollStyles.forEach(([el,value,priority]) => value ? el.style.setProperty('overflow',value,priority) : el.style.removeProperty('overflow'));
    scrollStyles = [];
    window.scrollTo({top:savedScroll,behavior:'instant'});
    if (previousFocus?.isConnected && previousFocus.getClientRects().length) previousFocus.focus({preventScroll:true});
  };
  const hide = () => { clearTimeout(opening); if (notice.open) notice.close(); };
  notice.addEventListener('close', restore);
  notice.querySelector('.ph-cart-notice__close').addEventListener('click', hide);
  notice.querySelector('.ph-cart-notice__continue').addEventListener('click', hide);
  notice.addEventListener('cancel', e => { e.preventDefault(); hide(); });
  notice.addEventListener('click', e => {
    if (e.target !== notice) return;
    const rect = notice.getBoundingClientRect();
    if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) hide();
  });
  let redirecting = false;
  window.addEventListener('pageshow', event => {
    if(event.persisted){redirecting=false;pending=null;lastSuccess=0;clearTimeout(opening);}
  });
  const show = () => {
    if (document.querySelector('script[data-ph-after-add]')?.dataset.phAfterAdd === 'cart') {
      if (redirecting) return;
      redirecting = true;
      window.dispatchEvent(new Event('ph-cart-redirecting'));
      clearTimeout(opening);
      window.location.assign(root + 'cart');
      return;
    }
    if (Date.now() - lastSuccess < 1200) return;
    lastSuccess = Date.now();
    const snapshot=pending || capture(), before=cartBefore, version=addVersion;
    pending=null;
    renderItem(null,null,null,snapshot);
    clearTimeout(opening);
    // Allow the native product preview to finish closing before locking the page.
    opening = setTimeout(() => {
      if (notice.open) return;
      previousFocus = document.activeElement; savedScroll = window.scrollY;
      notice.hidden = false; notice.showModal();
      scrollStyles = [document.documentElement,document.body].map(el => [el,el.style.getPropertyValue('overflow'),el.style.getPropertyPriority('overflow')]);
      scrollStyles.forEach(([el]) => el.style.setProperty('overflow','hidden','important'));
      document.documentElement.classList.add('ph-cart-notice-open');
      notice.querySelector('.ph-cart-notice__continue').focus({preventScroll:true});
    }, 150);
    readCart().then(cart => {
      if(version!==addVersion)return;
      const changed=cart.items.filter(item=>item.quantity>(before?.items?.find(i=>i.key===item.key)?.quantity || 0));
      const item=changed.find(i=>String(i.variant_id)===String(snapshot.variant)) || (changed.length===1?changed[0]:null);
      if(item)renderItem(item,cart,before,snapshot);
      cartBefore=cart;
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    }).catch(() => {});
  };
  window.addEventListener('customily-add-to-cart-completed', show);
  const cartJQuery = window.jQuery_T4NT || window.jQuery;
  if (cartJQuery) cartJQuery(document).on('add:cart:success.phNotice', show);
})();
